import { DateTime } from 'luxon';
import { ICDV3ServiceItem } from './ServiceInterfaces';
import { ICDV3ViewItem, IInterestPrepaymentViewItem } from '../interfaces/ICDViewItem';

const transformUndefinedToNull = <T>(val: T) => (val !== undefined ? val : null);

function toJSDate(val: string) {
  return DateTime.fromISO(val).toJSDate();
}

export const transformFromServiceItemToViewItem = (item: ICDV3ServiceItem): ICDV3ViewItem => {
  const {
    buyer_at_closing,
    buyer_before_closing,
    created_at,
    paid_by_others,
    seller_at_closing,
    seller_before_closing,
    ...rest
  } = item;
  const newItem = {
    ...rest,
    buyer_at_closing: transformUndefinedToNull(buyer_at_closing),
    buyer_before_closing: transformUndefinedToNull(buyer_before_closing),
    created_at: created_at,
    paid_by_others: transformUndefinedToNull(paid_by_others),
    seller_at_closing: transformUndefinedToNull(seller_at_closing),
    seller_before_closing: transformUndefinedToNull(seller_before_closing),
  };
  if (typeof item.date_from === 'string') {
    (newItem as IInterestPrepaymentViewItem).date_from = toJSDate(item.date_from);
  }
  if (typeof item.date_to === 'string') {
    (newItem as IInterestPrepaymentViewItem).date_to = toJSDate(item.date_to);
  }
  /** Actually need the cast, because at some point, we have to define the type */
  return newItem as ICDV3ViewItem;
};
